import { createContext } from "react";

interface TabContainerContextValue {
  $bs_tabContainer?: {
    activeKey?: any;
    onSelect?: (key: any) => void;
    getTabId?: (key: any) => string | null;
    getPaneId?: (key: any) => string | null;
  };
}

const TabContainerContext = createContext<TabContainerContextValue>({});

export default TabContainerContext;
